// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__BQj1C","checkboxCol":"Table_checkboxCol__2_U9s","emailCol":"Table_emailCol__QLnAJ","actionCol":"Table_actionCol__D9kGk"};